import { render, staticRenderFns } from "./ChangeLanguageModal.vue?vue&type=template&id=7ad6252a"
import script from "./ChangeLanguageModal.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeLanguageModal.vue?vue&type=style&index=0&id=7ad6252a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad6252a')) {
      api.createRecord('7ad6252a', component.options)
    } else {
      api.reload('7ad6252a', component.options)
    }
    module.hot.accept("./ChangeLanguageModal.vue?vue&type=template&id=7ad6252a", function () {
      api.rerender('7ad6252a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/ChangeLanguageModal.vue"
export default component.exports